import { Currency } from "../Currency.js";

export const membershipPricePerCurrencyMap: Record<Currency, number> = {
	[Currency.CZK]: 1,
	[Currency.EUR]: 0.05,
	[Currency.PLN]: 0.2,
};
